module.exports = __webpack_public_path__ + "img/result_ceil_lx.f84d8c6b.jpg";